module.exports = __webpack_public_path__ + "static/media/cobreFacilPromoImg.b0c704f1.png";